import { IMG } from '../../const';
import '../../assets/styles/report.scss';
import {
  discovery_roadmap,
  discovery_team,
  documents_1,
  documents_2,
} from './tabsConst';

const DiscoveryTab = ({ activeOption }) => {
  return (
    <div
      className={`report-page__tab${
        activeOption.id === 'discovery' ? ' activeTab' : ''
      }`}
    >
      <div className="summary-block">
        <div className="summary-block__label">Summary</div>
        <ul className="summary-block__list">
          <li>
            <div>90%</div>
            <div>accuracy</div>
          </li>
          <li>
            <div>5</div>
            <div>people in team</div>
          </li>
          <li>
            <div>€2,4K</div>
            <div>budget range</div>
          </li>
          <li>
            <div>2–4</div>
            <div>weeks</div>
          </li>
        </ul>
      </div>

      <div className="features-block">
        <div className="features-block__item">
          <div className="features-block__item-title">Discovery Phase</div>
          <p>
            The Discovery Phase helps transform your idea into a clear,
            structured, and development-ready product plan. It’s ideal for
            founders, startups, and product owners who want to reduce risk,
            avoid miscommunication, and get reliable cost & time estimates
            before investing in full-scale development.
          </p>
        </div>

        <div className="features-block__item height-fit-content">
          <div className="features-block__item-title">Team</div>
          <ul>
            {discovery_team.map((member) => (
              <li key={member.id}>
                {member.amount} {member.name}
              </li>
            ))}
          </ul>
        </div>
        <div className="features-block__item__wide">
          <div className="features-block__item-title">Documents you'll get</div>
          <div className="features-block__item-sub">
            <p>
              These documents will allow you to start development with any
              vendor
            </p>
          </div>
          <div className="features-block__item-flex">
            <div>
              <ul>
                {documents_1.map((item) => (
                  <li key={item.id}>{item.name}</li>
                ))}
              </ul>
            </div>
            <div>
              <ul>
                {documents_2.map((item) => (
                  <li key={item.id}>{item.name}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="summary-block">
        <div className="summary-block__label">Roadmap</div>
        <ul className="summary-block__roadmap">
          {discovery_roadmap.map((item) => (
            <li key={item.id}>
              <div className="summary-block__roadmap-text">
                <img
                  src={`${IMG.QUICK_QUOTE}/icons/${item.icon}.svg`}
                  width="44"
                  height="44"
                  loading="lazy"
                  alt={item.title}
                />
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
              <div className="summary-block__roadmap-runtime">
                {item.runtime}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DiscoveryTab;
